import { ShieldCheck, Briefcase, Target } from "lucide-react";

export const Community = () => {
  return (
    <section
      className="relative py-20 sm:py-24 md:py-32 btr-bg-graphite border-y border-white/5 overflow-hidden"
      data-testid="community-section"
    >
      <div className="absolute inset-0 btr-grid opacity-25 pointer-events-none" />
      <div
        className="btr-beam"
        style={{
          width: 420,
          height: 420,
          top: "-10%",
          left: "50%",
          transform: "translateX(-50%)",
          background: "#a2020b",
          opacity: 0.18,
        }}
      />
      <div className="relative max-w-6xl mx-auto px-5 sm:px-6 text-center">
        <div className="btr-reveal">
          <span className="btr-badge">
            <span className="dot" />
            Our Vision
          </span>
          <h2 className="font-display font-extrabold text-white text-3xl sm:text-4xl lg:text-6xl mt-6 leading-[1.05] sm:leading-[1.02] tracking-tight max-w-4xl mx-auto">
            A Vision Built for <span className="text-[#a2020b]">Protection</span>.
          </h2>
          <p className="font-body text-zinc-300/85 text-base sm:text-lg mt-6 sm:mt-7 max-w-3xl mx-auto leading-relaxed">
            Before The Risk was created to bring executive-level risk intelligence to property owners,
            attorneys, associations, and commercial stakeholders who cannot afford uncertainty. Our work
            is built on preparation, precision, and documentation that protects assets before exposure
            becomes liability.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5 mt-10 sm:mt-12 max-w-4xl mx-auto">
          {[
            {
              icon: ShieldCheck,
              title: "Executive Risk Intelligence",
              desc: "Fortune-grade strategy applied at the asset level.",
            },
            {
              icon: Briefcase,
              title: "Precision & Documentation",
              desc: "Defensible files built for boards, owners, and counsel.",
            },
            {
              icon: Target,
              title: "Protection Before Exposure",
              desc: "Anticipate liability — never react to it.",
            },
          ].map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={c.title}
                className="btr-reveal btr-glass rounded-lg p-6 text-left transition-colors hover:border-[#a2020b]/45"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <Icon className="w-5 h-5 text-[#a2020b]" strokeWidth={1.5} />
                <div className="font-display font-bold text-white text-base mt-4 leading-snug">
                  {c.title}
                </div>
                <div className="font-body text-zinc-400 text-sm mt-2 leading-relaxed">{c.desc}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
